// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-popup-image .frisbuy-image-area .frisbuy-advertising-marker{position:relative;width:-moz-fit-content;width:fit-content;margin:18px 0 0 16px;z-index:3}.frisbuy-popup-image .frisbuy-image-area .frisbuy-advertising-marker .frisbuy-popover__tooltip{width:calc(100vw - 32px);max-width:340px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
